// Where the browser reaches the bridge API (PRD 009 §4.5). In the hosted model
// the SPA is served from one origin (Pages) but talks to the bridge Worker at a
// DIFFERENT origin — so the base can no longer be assumed same-origin. The Worker
// origin is a build-time constant (Vite env), with a Settings override on top:
//
//   user override (keys.bridgeUrl)  →  build-time VITE_BRIDGE_API_ORIGIN  →  ''
//
// '' means same-origin — the legacy local-gateway path (the gateway served the
// SPA itself), still supported so a self-host-on-loopback build keeps working.

export const BRIDGE_API_ORIGIN = (import.meta.env.VITE_BRIDGE_API_ORIGIN ?? '')
  .trim()
  .replace(/\/+$/, '')

/** Resolve the effective bridge origin: an explicit Settings override wins, else
 *  the build-time hosted origin, else '' (same-origin). */
export function resolveBridgeEndpoint(bridgeUrl?: string | null): string {
  return bridgeUrl?.trim() || BRIDGE_API_ORIGIN || ''
}
